<template>
  <Teleport to="#vue-portal">
    <Transition name="modal">
      <div v-if="show" class="Modal" @click.self="onClose">
        <div class="Modal-dialog" :class="{ 'is-mini': isMini }">
          <div class="Modal-header">
            <h2 class="Modal-title">
              <icon v-if="icon" class="Modal-titleIcon" :name="icon"/> {{title}}
            </h2>
            <button class="Modal-close" @click="onClose" aria-label="Close">
              <icon name="close"></icon>
            </button>
          </div> 
          <div class="Modal-content">
            <div v-if="content" v-html="content"/>
            <slot v-else/>
          </div>   
        </div>   
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import Icon from './Icon.vue';
export default {
  components: { Icon },

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
  },

  watch: {
    show() {
      if(this.show) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }
    }
  },

  methods: {
    handleKeyDown(e) {
      if( e.key === "Escape" && this.show ) {
        this.onClose();
      }
    }
  },

  props: {
    title: {
        type: String,
        default: ""
    },
    icon: {
        type: String,
        default: ""
    },
    show: {
        type: Boolean,
        default: false
    },
    content: {
        type: String,
        default: null
    },
    onClose: {
        type: Function,
        default: () => {}
    },
    isMini: {
      type: Boolean,
      default: false
    }
  }    
}
</script>